import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import './RegistrationFees.css';

const RegistrationForm = () => {
    const [rows, setRows] = useState([
        { id: 1, category: 'Abstract/Poster Presentation' },
        { id: 2, category: 'Participant' }
    ]);

    const categories = [
        'Abstract/Poster Presentation',
        'Participant'
    ];

    const save = async () => {
        try {
            const data = rows.map(row => ({
                category: row.category,
                justStudent: document.getElementsByName(`just-student-${row.id}`)[0].value,
                justProfessional: document.getElementsByName(`just-professional-${row.id}`)[0].value,
                othersStudent: document.getElementsByName(`others-student-${row.id}`)[0].value,
                othersProfessional: document.getElementsByName(`others-professional-${row.id}`)[0].value,
            }));

            await axios.put(`${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/registration-fee`, data, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Data updated successfully!',
                confirmButtonText: 'OK'
            });

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Error saving data!',
                confirmButtonText: 'Try Again'
            });
            console.error('Error saving data:', error);
        }
    };

    return (
        <div className="registration-form">
            <h2 className="form-title mb-4 text-center">Registration Fees</h2>
            {rows.map((row, index) => (
                <div key={row.id} className="fee-table mb-4 p-3 border rounded">
                    <h5 className="text-primary mb-3">{row.category}</h5>
                    <div className="row mb-2">
                        <div className="col-3"><strong></strong></div>
                        <div className="col-2 text-center"><strong>JUST - Student</strong></div>
                        <div className="col-2 text-center"><strong>JUST - Professional</strong></div>
                        <div className="col-2 text-center"><strong>OTHERS - Student</strong></div>
                        <div className="col-2 text-center"><strong>OTHERS - Professional</strong></div>
                    </div>
                    <div className="row align-items-center mb-3">
                        <div className="col-3"><strong>Fee (BDT):</strong></div>
                        <div className="col-2">
                            <input type="number" name={`just-student-${row.id}`} className="form-control" required />
                        </div>
                        <div className="col-2">
                            <input type="number" name={`just-professional-${row.id}`} className="form-control" required />
                        </div>
                        <div className="col-2">
                            <input type="number" name={`others-student-${row.id}`} className="form-control" required />
                        </div>
                        <div className="col-2">
                            <input type="number" name={`others-professional-${row.id}`} className="form-control" required />
                        </div>
                    </div>
                </div>
            ))}
            <button className="btn btn-success save" onClick={save}>Update</button>
        </div>
    );
};

export default RegistrationForm;
